<template>
  <div>
    <!-- 添加 -->
    <div class="Examin_view">
      <el-dialog
        title="添加考生"
        :visible.sync="dialogVisibleObj.addExamineeShow"
        :before-close="handleBeforeClose"
      >
        <div class="examin_mian">
          <div class="examin_head">
            <el-form
              :label-position="labelPosition"
              label-width="80px"
              :model="formLabelAlign"
              @selection-change="handleSelectionChange"
            >
              <el-form-item label="姓名：">
                <el-input
                  v-model.trim="formLabelAlign.name"
                  placeholder="请输入考生姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="账号：">
                <el-input
                  v-model.trim="formLabelAlign.userName"
                  placeholder="请输入考生账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="职称：">
                <el-select v-model="formLabelAlign.region" placeholder="全部">
                  <!-- <el-option label="区域一" value="shanghai"></el-option>
                  <el-option label="区域二" value="beijing"></el-option> -->
                  <el-option
                    v-for="item in getPTitleData"
                    :key="item.PTitle"
                    :label="item.PTitle"
                    :value="item.PTitle"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="职位：">
                <el-select v-model="formLabelAlign.position" placeholder="全部">
                  <!-- <el-option label="医生" value="shanghai"></el-option>
                  <el-option label="护士" value="beijing"></el-option> -->
                  <el-option
                    v-for="item in getPositionData"
                    :key="item.Position"
                    :label="item.Position"
                    :value="item.Position"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="科室">
                <el-select
                  v-model="formLabelAlign.departmentName"
                  placeholder="全部"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="item in getDepartmentData"
                    :key="item.DepartmentID"
                    :label="item.DepartmentName"
                    :value="item.DepartmentName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="query_btn">
              <el-button
                @click="handleQuery()"
                type="primary"
                icon="el-icon-search"
                class="searchbtn"
                >搜索</el-button
              >
              <el-button
                @click="resetQuery()"
                icon="el-icon-refresh"
                class="searchbtn sonbtn"
                >重置</el-button
              >
            </div>
          </div>
          <!-- 表格 -->
          <div class="examinee_form">
            <el-table
              ref="table"
              :data="getData"
              style="width: 100%"
              height="300"
              :row-class-name="tableRowClassName"
              @selection-change="handleSelectionChange"
              :header-cell-style="{
                'background-color': '#8FCBFF',
                color: '#333333',
                height: '60px',
              }"
            >
              <el-table-column type="selection" width="80"></el-table-column>

              <el-table-column type="index" label="序号"
                ><template slot-scope="scope">
                  <span>{{
                    (currentPage - 1) * pageSize + scope.$index + 1
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column
                v-for="(item, index) in formColumns"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
                height="150"
                label-height="50"
                align="center"
              >
                <template slot-scope="scope">
                  <p v-if="index == 0">{{ scope.row.UserName }}</p>
                  <p v-if="index == 1">{{ scope.row.RealName }}</p>
                  <p v-if="index == 2">{{ scope.row.PTitle }}</p>
                  <p v-if="index == 3">{{ scope.row.Position }}</p>
                  <p v-if="index == 4">{{ scope.row.DepartmentName }}</p>
                  <p v-if="index == 5">
                    {{
                      scope.row.Birthday == null
                        ? null
                        : $moment(scope.row.Birthday).format("YYYY-MM-DD")
                    }}
                  </p>
                  <p v-if="index == 6">{{ scope.row.JobDate }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="foot_box">
            <div class="foot_pagetions">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                @prev-click="handlePrevClick"
                @next-click="handleNextClick"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                :page-sizes="pagesizesArr"
                layout="prev, pager, next, sizes, jumper"
                :total="total"
                class="pagination"
                v-loading="isLoading"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancle()">取 消</el-button>
          <el-button type="primary" @click="handleConfirm()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getStudentList, SaveAddGroupStudent } from "@/services/examManager.js";

export default {
  data() {
    return {
      dialogVisibleObj: {
        addExamineeShow: false,
      },
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        userName:'',
        account: "",
        department: "",
        departmentName:'',
        region: "",
        position: "",
      },
      examListPara: {},
      getDepartmentData: [],
      getPositionData: [],
      getPTitleData: [],
      getData: [],
      keshioptions: [], //全部科室的列表
      multipleSelectionAll: [], // 所有选中的数据包含跨页数据
      multipleSelection: [], // 当前页选中的数据
      changePageCoreRecordDataStats: true,
      idKey: "UserID",
      formColumns: [
        {
          prop: "UserName",
          label: "考生账号",
        },
        {
          prop: "RealName",
          label: "考生姓名",
        },
        {
          prop: "PTitle",
          label: "职称",
        },
        {
          prop: "Position",
          label: "职位",
        },
        {
          prop:'DepartmentName',
          label:'科室'
        },
        {
          prop: "Birthday",
          label: "出生日期",
        },
        {
          prop: "JobDate",
          label: "工作年限",
        },
      ],
      currentPage: 1,
      pageSize: 50,
      pagesizesArr: [50, 100, 200],
      total: 100,
      examListData: [],
      isLoading: false,
    };
  },
  methods: {
    // 搜索
    handleQuery() {
      // 初始化多选框
      this.multipleSelectionAll = [];
      this.multipleSelection = [];
      // 初始化查询接口请求参数
      this.currentPage = 1;
      if (this.formLabelAlign.name) {
        this.examListPara.realName = this.formLabelAlign.name;
      }
      if (this.formLabelAlign.userName) {
        this.examListPara.userName = this.formLabelAlign.userName;
      }
      if (this.formLabelAlign.region) {
        this.examListPara.pTitle = this.formLabelAlign.region;
      }
      if (this.formLabelAlign.position) {
        this.examListPara.position = this.formLabelAlign.position;
      }
       if (this.formLabelAlign.departmentName) {
        this.examListPara.departmentName = this.formLabelAlign.departmentName;
      }
      this.getStudentList();
      // 重置查询接口请求参数
      // this.examListPara.realName = "";
      // this.examListPara.pTitle = "";
      // this.examListPara.position = "";  // 11.14 搞不懂久庆为什么要重置
    },
    // 输入框重置
    resetQuery() {
      // 初始化条件筛选框
      this.formLabelAlign.name = "";
      this.formLabelAlign.region = "";
      this.formLabelAlign.userName = "";
      this.formLabelAlign.position = "";
      // 初始化多选框
      this.multipleSelectionAll = [];
      this.multipleSelection = [];
      // 初始化查询接口请求参数
      this.currentPage = 1;
      this.examListPara.realName = "";
      this.examListPara.userName = "";
      this.examListPara.pTitle = "";
      this.examListPara.position = "";
      this.examListPara.departmentName = "";
      this.getStudentList();
    },

    // 弹窗关闭前触发
    handleBeforeClose(done) {
      this.handleCancle();
      done();
    },

    handleCancle() {
      // 初始化条件筛选框
      this.formLabelAlign.name = "";
      this.formLabelAlign.region = "";
      this.formLabelAlign.position = "";
      this.formLabelAlign.departmentName = "";
      // 初始化多选框
      this.multipleSelectionAll = [];
      this.multipleSelection = [];
      // 初始化查询接口请求参数
      this.currentPage = 1;
      this.pageSize = 5;
      this.examListPara.realName = "";
      this.examListPara.userName = "";
      this.examListPara.departmentName = "";
      this.examListPara.pTitle = "";
      this.examListPara.position = "";
      this.getStudentList();
      // 关闭弹窗
      this.dialogVisibleObj.addExamineeShow = false;
      this.$emit("cancle");
    },

    async handleConfirm() {
      const reqParam = new Object();
      this.UtilFun(reqParam);
      let row = this.$parent.$parent.$children[0].rowData;
      reqParam.groupID = row.groupID;
      reqParam.userArr = `[${this.getAllSelectionUserID()}]`;
      console.log(reqParam, "确定添加考生按钮请求数据");
      const { data } = await SaveAddGroupStudent(reqParam);
      console.log(data, "确定添加考生按钮返回数据");
      if (data.Status == 200) {
        this.formLabelAlign.name = "";
        this.formLabelAlign.region = "";
        this.formLabelAlign.position = "";
        this.multipleSelectionAll = [];
        this.multipleSelection = [];
        this.currentPage = 1;
        this.pageSize = 5;
        this.getStudentList();
        this.dialogVisibleObj.addExamineeShow = false;
        this.$emit("success");
        this.$message.success("添加成功");
        this.$parent.$parent.$children[1].memberManageListData();
      } else {
        this.$message.error("添加失败");
      }
    },

    // pageData: (number, pageSize, data) => {
    //   const pageList = [];
    //   const start = pageSize * number - pageSize;
    //   const end = pageSize * number;
    //   for (let i = start; i < end; i++) {
    //     pageList.push(data[i]);
    //   }
    //   const list = pageList.filter((item) => item);
    //   return list;
    // },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },

    // 设置选中的方法
    setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.getData.length; i++) {
        if (selectAllIds.indexOf(this.getData[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.getData[i], true);
        }
      }
    },

    // 记忆选择核心方法
    changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      let selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      let selectIds = [];
      // 获取当前页选中的id
      this.multipleSelection.forEach((row) => {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      let noSelectIds = [];
      // 得到当前页没有选中的id
      this.getData.forEach((row) => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach((id) => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },

    // 得到选中的所有数据
    getAllSelectionData() {
      // 再执行一次记忆勾选数据匹配，目的是为了在当前页操作勾选后直接获取选中数据
      this.changePageCoreRecordData();
      return this.multipleSelectionAll;
    },

    // 得到选中的所有数据的id
    getAllSelectionUserID() {
      let data = this.getAllSelectionData();
      let UserIDs = [];
      data.forEach((element) => {
        UserIDs.push(element.UserID);
      });
      return UserIDs;
    },

    // 显示条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.changePageCoreRecordData();
      this.pageSize = val;
      this.getStudentList();
      console.log(`每页 ${val} 条`);
    },

    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.changePageCoreRecordData();
      this.currentPage = val;
      this.changePageCoreRecordDataStats = false;
      this.getStudentList();
    },

    // 上一页
    handlePrevClick() {
      this.getStudentList();
    },
    // 下一页
    handleNextClick() {
      this.getStudentList();
    },

    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log("多选框选中数据...");
      this.multipleSelection = selection;
      if (this.changePageCoreRecordDataStats) {
        this.changePageCoreRecordData();
      }
      this.multiple = !this.multipleSelectionAll.length;
    },

    getDialogVisibleObj(status) {
      this.dialogVisibleObj.addExamineeShow = status;
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },

    // 获取考生列表数据
    async getStudentList() {
      const examListPara = this.examListPara;
      this.UtilFun(examListPara);
      let row = this.$parent.$parent.$children[0].rowData;
      examListPara.groupID = row.groupID;
      examListPara.key = "studentGroup";
      examListPara.pageIndex = this.currentPage - 1;
      examListPara.pageShow = this.pageSize;
      examListPara.showMode = "student";
      console.log(examListPara, "~~~获取考生列表数据请求数据");
      this.isLoading = true;
      const { data } = await getStudentList(examListPara);
      console.log(data, "~~~获取考生列表数据返回数据");
      if (data.Status === 200) {
        const arrData = data.Data;
        this.examListData = arrData[0];
        this.getData = this.examListData;
        this.total = arrData[1][0].dataCount;
        this.getDepartmentData = arrData[2];
        this.getPositionData = arrData[3];
        this.getPTitleData = arrData[4];
        this.isLoading = false;
        setTimeout(() => {
          this.changePageCoreRecordDataStats = true;
          this.setSelectRow();
        }, 200);
      } else {
        this.$message.error(data.Data);
      }
    },
  },
  activated() {
    this.getStudentList();
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.Examin_view {
  box-sizing: border-box;
  .title_box {
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
    margin-bottom: 50px;
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
    width: 103px;
    height: 42px;
  }
  ::v-deep .el-dialog {
    width: 1041px;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .el-dialog__header {
    padding: 0px 24px;
  }
  .examin_head {
    padding: 30px 24px 10px 10px;
    display: flex;
    ::v-deep .el-form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: 250px !important;
      }
      .el-input__inner {
        width: 160px;
      }
    }
    .query_btn {
      display: flex;
      .el-button {
        width: 88px;
        height: 40px;
        margin-left: 24px;
      }
    }
  }
  .examinee_form {
    padding: 0px 20px 0px 34px;
  }
}
.Examin_view {
  box-sizing: border-box;
  .title_box {
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
    margin-bottom: 50px;
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
    width: 103px;
    height: 42px;
  }
  ::v-deep .el-dialog {
    width: 1041px;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .el-dialog__header {
    padding: 0px 24px;
  }
  // .examin_head {
  //   padding: 30px 24px 10px 10px;
  //   display: flex;
  //   .el-form {
  //     display: flex;
  //   }
  //   .query_btn {
  //     display: flex;
  //     .el-button {
  //       width: 88px;
  //       height: 40px;
  //       margin-left: 24px;
  //     }
  //   }
  // }
  .examinee_form {
    padding: 0px 20px 0px 34px;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  line-height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
    &:nth-child(2) {
      margin-left: 90px;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  top: 30px;

  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
  ::v-deep .el-pagination__jump {
    margin: 0px 10px 0px 0px !important;
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
</style>